import { flow, get, toPairs, find, startsWith, defaultTo, toLower, mergeAll } from 'lodash/fp';
import Cookies from 'js-cookie';
import { sites } from './globalVariables';

const getRepId = () => {
  const value = Cookies.get('internalUser');
  if (!value) {
    return null;
  }

  const repId = value.split(':')[0].split('\\')[1];
  return repId;
};

function getMandiBaseUrl() {
  let url = 'http://install.hd.localtest.me';

  if (window.pageContextJavascript && window.pageContextJavascript.estimateBuilder) {
    url = window.pageContextJavascript.estimateBuilder.mandiBaseUrl;
  }

  return url;
}

const defaultConfiguration = {
  designBuilderApiBaseUrl: 'http://designbuilderapi.localtest.me',
  designBuilderSaveDesignPath: '/designs',
  designBuilderLoadDesignPath: '/designs',
  designBuilderEditMeasurementsPath: '/designs',
  designBuilderGetDesignsSummaryPath: '/designs/summary',
  designBuilderBuyDesignPath: '/estimates/<guid>/buy',
  designBuilderLinkToMyAccountPath: '/estimates/<guid>/link',
  designBuilderSetItemAttributePath: '/designs',
  designBuilderDeleteItemAttributePath: '/designs',
  designBuilderShareEstimate: 'estimates/share',
  designBuilderGetDcSignature: '/dcinfo/signature/<repId>/<siteId>',
  designBuilderSaveDcSignature: '/dcinfo/signature',
  designBuilderBrokerSaveDesignPath: '/designs/brokerSaveDesign',
  designBuilderSendSavedDesignEmail: '/estimates/sendSavedDesignEmail',
  designBuilderGetStoreInfo: 'interconnected-quotes/storeInfo',
  eleanorDesignBuilderProxyLinkToMyAccount: '/api/myaccount/estimates/link',
  estimateBuilderAddtoCart: '/estimatebuilder/addtocart', // a server endpoint
  cartUrl: '/Ordering/Cart',
  setEstimateInfoUrl: '/EstimateShopping/SetEstimateInfo',
  designBuilderApiKey: '',
  createMandiEstimateApi: '/api/customer/createmandiestimate',
  addressValidationApi: '/api/customer/addressvalidation/v1/validate',
  serviceProvidersApi: '/api/service-providers/check-availability',
  checkStoreAvailabilityApi: '/api/service-providers/check-store-availability',
  setAddressApi: '/api/customer/profile/temp/setaddress',
  mandiAddressKey: 'MI_PropertyAddress',
  mandiContactInfo: 'MI_ContactInformation',
  mandiLandingPage: '/mandi/bookmeasure?cameFromEstimatePage=true',
  nbiLandingPage: '/infopage/mandi-nbi-locate-if-link',
  supportPhoneNumber: '000-000-000',
  plpUrl: {
    estimate: '/Catalog/SiteProduct/ProductSearch',
    mandi: '/Catalog/SiteProduct/EstimateSearchMandi',
  },
  ronaeleBaseUrl: 'http://ronaele.localtest.me',
  mandiBaseUrl: getMandiBaseUrl(),
  newMandiBaseUrl: 'http://mandi.localtest.me',
  ProductMapApi: '/estimates/productid-map',
  thdCartBatchSize: 5,
  thdCartCalmRate: 1000,
  estimatebuilderBasePaths: {
    mandi: '/estimatebuilder/mandi',
    chuck: '/estimatebuilder',
  },
  estimatebuilderLoadPath: '/load',
  estimatebuilderSummaryPath: '/summary',
  wellKnownProductIds: {
    mandi: {
      M: '',
      I: '',
    },
  },
};

const siteSpecificConfigurations = {
  [sites.americanBlinds]: {},
  [sites.blinds]: {
    wellKnownProductIds: {
      mandi: {
        M: '',
        I: 533459,
      },
    },
  },
  [sites.blindsCa]: {},
  [sites.justBlinds]: {},
  [sites.theHomeDepot]: {
    mandiLandingPage: `${getMandiBaseUrl()}/schedule/bookappointment`,
    plpUrl: {
      estimate: '/catalog/estimatebuildersearch',
      mandi: '/catalog/siteproduct/estimatesearch',
    },
  },
};

function getConfigFromWindow() {
  const { siteId } = window.globalConfig;
  const configs = [defaultConfiguration, siteSpecificConfigurations[siteId]];

  if (window.pageContextJavascript && window.pageContextJavascript.estimateBuilder) {
    configs.push(window.pageContextJavascript.estimateBuilder);
    configs.push({
      repId: getRepId,
    });
  }

  const configuration = mergeAll(configs);
  configuration.siteId = siteId;

  configuration.estimatebuilderMode = flow(
    toPairs,
    find(([, path]) => startsWith(toLower(path))(toLower(window.location.pathname))),
    get('0'),
    defaultTo('chuck'),
  )(configuration.estimatebuilderBasePaths);

  configuration.estimatebuilderBasePath = (
    configuration.estimatebuilderBasePaths[configuration.estimatebuilderMode]
  );

  return configuration;
}

const config = getConfigFromWindow();

export default config;
